import { MorningCoin } from './BackendAdminClient/morning-coin'
import { Subscriptions } from './BackendAdminClient/subscriptions'
import { User } from './BackendAdminClient/user'
import { Provider } from './BackendAdminClient/provider'
import { Receipt } from './BackendAdminClient/receipt'
import { Subscriber } from './BackendAdminClient/subscriber'
export class BackendAdminClient {
  get token() {
    return localStorage.getItem("accessToken") || ''
  }

  get headers() {
    return { 'Authorization': `Bearer ${this.token}` }
  }

  get backendUrl() {
    return `${process.env.ADMIN_HOST}/ruejai-backend-admin`
  }

  constructor() {
    // Set api url
    const apiUrl = `${this.backendUrl}/api`;

    // Morning Coin
    this.morningCoin = new MorningCoin(apiUrl, this.headers);
    // Subscriptions
    this.subscriptions = new Subscriptions(apiUrl, this.headers);
    // User
    this.user = new User(apiUrl, this.headers);
    // Provider
    this.provider = new Provider(apiUrl, this.headers);
    // Receipt
    this.receipt = new Receipt(apiUrl, this.headers);
    // Subsciber
    this.subscriber = new Subscriber(apiUrl, this.headers);
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient.js